import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Slide,
  TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { withAplicacao } from '../../contexts/AplicacaoContext';
import IntegrationAutosuggestGlosa from './IntegrationAutosuggestGlosa';
import LinearProgressBlockScreen from './LinearProgressBlockScreen';
import Utils from './Utils';

const styles = theme => ({
  root: {
    display: 'block',
  },
  textField: {
    margin: theme.spacing(1),
    width: 900,
  },
  group: {
    margin: `${theme.spacing(1)}px 0`,
  },
  formControlAutoCompleteGlosa: {
    margin: theme.spacing(1),
    minWidth: 900,
  },
});
function Transition (props) {
  return <Slide direction='down' {...props} />;
}

class AlertDialogSlide extends React.Component {
  utils = new Utils();
  state = {
    valorCampoDialog: '',
    motivosDeGlosa: [],
    motivoDeGlosaSelected: 0,
    desMensagemGlosaSelected: '',
    salvarDisabled: true,
    loading: true
  }
  handleClickConfirmar = () => {
    this.props.handleClickIncluirGlosa(this.state.motivoDeGlosaSelected, this.state.desMensagemGlosaSelected, this.state.valorCampoDialog);
  }
  handleChangeText = event => {
    var novoValor = event.target.value;
    this.setState({ [event.target.name]: novoValor.toUpperCase() });
  };

  getSuggestionValueGlosa = (suggestion, codMensagemGlosa) => {
    this.setState({
      motivoDeGlosaSelected: codMensagemGlosa !== undefined ? codMensagemGlosa : suggestion.codMensagemGlosa,
      desMensagemGlosaSelected: suggestion.desMensagemGlosa !== undefined ? suggestion.desMensagemGlosa : suggestion.substring(7, suggestion.length),
      salvarDisabled: codMensagemGlosa === undefined || codMensagemGlosa === 0 });
    return suggestion.codMensagemGlosa + ' - ' + suggestion.desMensagemGlosa;
  }

  handleClose = () => {
    this.setState({valorCampoDialog: '', motivoDeGlosaSelected: 0});
    this.props.handleClose();
  }

  componentDidMount = async () => {
    await this.consultarMotivosGlosa();
  }

  consultarMotivosGlosa = async () => {
    const motivosDeGlosa = await this.props.getMotivosDeGlosa();
    this.setState({motivosDeGlosa: motivosDeGlosa, loading: false});
  }

  render () {
    const { open, handleClose, title, message, classes } = this.props;

    return (
      <div>
        {this.state.loading ? <LinearProgressBlockScreen />
          : <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            fullWidth
            maxWidth='md'
            onClose={handleClose}
            aria-labelledby='alert-dialog-slide-title'
            aria-describedby='alert-dialog-slide-description'
          >
            <DialogTitle id='alert-dialog-slide-title'>
              {title}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='alert-dialog-slide-description'>
                {message}
              </DialogContentText>
              <FormControl className={classes.formControlAutoCompleteGlosa}>
                <IntegrationAutosuggestGlosa
                  getSuggestionValue={this.getSuggestionValueGlosa}
                  suggestions={this.state.motivosDeGlosa}
                  placeholder={'Digite o motivo de glosa...'} />
              </FormControl>
              <div className={classes.root}>
                <TextField
                  // autoFocus
                  className={classes.textField}
                  margin='dense'
                  name='valorCampoDialog'
                  label={'Observação'}
                  fullWidth
                  multiline
                  style={{maxlength: '500'}}
                  value={this.state.valorCampoDialog}
                  maxRows='10'
                  onChange={this.handleChangeText}
                  helperText='(max. 500 caracteres)'
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color='primary'>
                Sair
              </Button>
              <Button
                onClick={this.handleClickConfirmar}
                disabled={this.state.salvarDisabled}
                color='primary'>
                Confirmar
              </Button>
            </DialogActions>
          </Dialog>}
      </div>
    );
  }
}
export default withAplicacao(withStyles(styles)(AlertDialogSlide));
